import { action, observable } from 'mobx';
import { BaseStore } from '~web/store/base/base-store';

export class MalformedLinkStore extends BaseStore {
  @observable hasMalformedLink: boolean;

  constructor() {
    super();
    this.hasMalformedLink = false;
  }

  /**
   * Show the link malformed overlay
   */
  @action
  setLinkMalformed(): void {
    this.hasMalformedLink = true;
  }

  /**
   * Finish any active flow
   */
  finish(): void {
    this.hasMalformedLink = false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/store/assignments/malformed-link.store.ts